import { NumericFormat } from 'react-number-format';

export const FormatMoney = ({ value, suffix = '€', prefix = '€', decimalScale = 0, renderText}) => {
  return (
    <NumericFormat
      value={value}
      // suffix={` ${suffix}`}
      prefix={value < 0 ? ` ${prefix} ` : `${prefix} `}
      thousandSeparator=" "
      displayType="text"
      decimalScale={decimalScale}
      renderText={renderText}
    />
  );
};

export const FormatNumberToOneDigit = ({ value }) => {
  return (
    <NumericFormat
      value={value}
      thousandSeparator=" "
      displayType="text"
      decimalScale={1} 
    />
  );
};

export const FormatNumberToTwoDigits = ({ value }) => {
  return (
    <NumericFormat
      value={value}
      thousandSeparator=" "
      displayType="text"
      decimalScale={2} 
    />
  );
};